export default {
  removeExtension(filename) {
    return filename.replace(/\.[^.]+$/, '')
  },

  async compressBlob(blob) {
    const stream = blob.stream()
    const compressedStream = stream.pipeThrough(new CompressionStream('gzip'))
    const compressedResponse = await new Response(compressedStream)

    return await compressedResponse.blob()
  },

  async decompressBlob(blob) {
    const ds = new DecompressionStream('gzip')
    const decompressedStream = blob.stream().pipeThrough(ds)

    return await new Response(decompressedStream).blob()
  },
}
